module.exports = __webpack_public_path__ + "static/media/6.043189b0.JPG";